import React from 'react';
import { IonButton, IonIcon, IonCol } from '@ionic/react';
import './UploadPrescription.scss';
import { STRINGS } from '../../i18n/strings';
import { trashOutline, checkmark, close } from 'ionicons/icons';

import banOutline from '../../assets/images/ban-outline.svg';

import { Prescription } from '../../repositories/FileRepository';

type Props = {
  prescription: Prescription;
  fileName: string;
  removeFile: (index: number) => void;
  index: number;
};

const UploadPrescriptionChecker: React.FC<Props> = ({
  prescription,
  fileName,
  removeFile,
  index
}) => {
  return (
    <IonCol key={index}>
      <IonButton
        size="small"
        shape="round"
        className="prescription-image-delete"
        onClick={() => removeFile(index)}
      >
        <IonIcon slot="icon-only" size="small" icon={trashOutline} />
      </IonButton>
      {prescription.success ? (
        <div className="text-success">
          <h2 style={{ color: 'green' }}>
            La photo de votre ordonnance est conforme
          </h2>
        </div>
      ) : (
        <div className="text-danger">
          <h2 style={{ color: 'red' }}>
            La photo de votre ordonnance n’est pas conforme
          </h2>
        </div>
      )}
      {prescription.errorCodes[0] === 'PDF_HAS_MULTIPLE_PAGES' ? (
        <img
          alt="ordonnance"
          src={banOutline}
          className="prescription-error-image ion-margin-bottom"
        />
      ) : (
        <img
          alt="ordonnance"
          src={prescription.image}
          className="prescription-image ion-margin-bottom"
        />
      )}
      <br />

      {prescription.success ? (
        <IonIcon size="large" className="checkmarkIcon" icon={checkmark} />
      ) : (
        prescription.errorCodes[0] !== 'PDF_HAS_MULTIPLE_PAGES' && (
          <IonIcon size="large" className="checkmarkIcon" icon={close} />
        )
      )}
      <div className="ion-margin-top">{fileName}</div>
      {prescription.errorCodes.length > 0 ? (
        <div className="text-danger">
          {prescription.errorCodes[0] === 'PDF_HAS_MULTIPLE_PAGES' ? (
            <h4 style={{ color: 'red', fontWeight: 'bold' }}>
              Le fichier pdf comporte une erreur :
            </h4>
          ) : (
            <h4 style={{ color: 'red', fontWeight: 'bold' }}>
              Certaines informations ne sont pas visibles :
            </h4>
          )}
          {prescription.errorCodes.map((errorCode, index) => (
            <div style={{ color: 'red' }} key={index}>
              -
              {
                STRINGS.FR[
                  `PRESCRIPTION_ERROR_${errorCode}` as keyof typeof STRINGS.FR
                ]
              }
            </div>
          ))}
        </div>
      ) : null}
    </IonCol>
  );
};

export default UploadPrescriptionChecker;
